import React, { useState, useEffect } from 'react';
import MEDIA_TYPE from '../../../_shared/constants/media';
import Icon from '../../../_shared/components/Icon';
import { MediaType } from '../../../_shared/types/media';

import {
  MediaContainer,
  CheckboxContainer,
  Checkbox,
  StyledEmptyIcon,
  Image,
  Video
} from './Styles';

const Media = ({ retailMediaList, idkey, media, mediaType, setSelectAll }) => {
  const [isImageChecked, setIsImageChecked] = useState(true);
  const onClick = e => {
    // Disable the check/uncheck on the video thumbnail
    if (e?.currentTarget?.getElementsByTagName('video')?.length) {
      return;
    }

    const checkbox = e?.currentTarget?.className.includes('checkbox')
      ? e?.currentTarget
      : e?.currentTarget?.getElementsByClassName('checkbox')[0];
    const isChecked = checkbox?.getAttribute('aria-checked');

    retailMediaList.find(el => el.id === media.id).isChecked =
      isChecked !== 'true';

    checkbox?.setAttribute(
      'aria-checked',
      isChecked === 'true' ? 'false' : 'true'
    );
    setIsImageChecked(isChecked !== 'true');

    // Toggle select/deselect every check/uncheck
    const subsetMediaList = retailMediaList.filter(
      list => list.mediaType === MEDIA_TYPE[mediaType]
    );
    const hasUnselected = !!subsetMediaList.filter(
      list => list.isChecked === false
    )?.length;

    setSelectAll(select => ({
      ...select,
      [MEDIA_TYPE[mediaType]]: hasUnselected
    }));
  };

  const idx = retailMediaList.findIndex(ele => ele.id === media.id);
  let preCheckVal = 'true';
  if (idx !== -1) {
    preCheckVal = retailMediaList[idx].isChecked ? 'true' : 'false';
  }

  useEffect(() => {
    const currentMedia = retailMediaList.filter(
      mediaEl => mediaEl.id === idkey
    );
    const wasChecked = currentMedia[0]?.isChecked;

    if (typeof wasChecked === 'boolean') {
      setIsImageChecked(wasChecked);
    }
  }, [idkey, retailMediaList]);

  return (
    <MediaContainer onClick={onClick} isChecked={isImageChecked}>
      <CheckboxContainer
        className="checkbox"
        role="checkbox"
        aria-checked={preCheckVal}
        onClick={onClick}
      >
        <Checkbox />
        <Icon icon="TR5-Toggle_check" />
      </CheckboxContainer>
      {!media && <StyledEmptyIcon />}
      {media && media.type !== MediaType.video ? (
        <Image
          id={`${idkey}image`}
          key={`${idkey}image`}
          src={media.externalUrl}
          isChecked={isImageChecked}
        />
      ) : (
        <Video
          id={idkey}
          controls
          disablePictureInPicture
          playsInline
          controlsList="nodownload"
        >
          <source src={`${media.externalUrl}#t=0.001`} type="video/mp4" />
        </Video>
      )}
    </MediaContainer>
  );
};

export default Media;
